import {
  AdditionalMultimediaInfo,
  MultimediaMessageContent,
  MultimediaInfo,
  ResizedImageInfo
} from '@/types/matrix';
import {MatrixClient, MsgType} from 'matrix-js-sdk';

export const sendImages = async (
  matrixClient: MatrixClient,
  currentMatrixRoomId: string,
  images: ResizedImageInfo[],
  text: string
): Promise<string> => {
  try {
    let firstImageContent: MultimediaMessageContent | undefined;
    const additionalImageInfos: AdditionalMultimediaInfo[] = [];
    let sentEventId = '';

    for (let index = 0; index < images.length; index++) {
      const {file, width, height} = images[index];
      const uploadResponse = await matrixClient.uploadContent(file);
      const imageUrl = uploadResponse.content_uri;

      if (typeof imageUrl !== 'string') {
        throw new Error('Cannot fetch image url');
      }

      const imgInfo: MultimediaInfo = {
        w: Math.round(width),
        h: Math.round(height),
        mimetype: file.type,
        index: index
      };

      if (index === 0) {
        firstImageContent = {
          url: imageUrl,
          info: imgInfo,
          body: text,
          additional: []
        };
      } else {
        additionalImageInfos.push({url: imageUrl, info: imgInfo});
      }
    }
    if (images.length > 1 && firstImageContent) {
      firstImageContent.additional = additionalImageInfos;
    }

    if (firstImageContent) {
      const response = await matrixClient.sendMessage(currentMatrixRoomId, {
        msgtype: MsgType.Image,
        body: firstImageContent.body ?? '',
        ...firstImageContent
      });
      sentEventId = response.event_id;
    }

    return sentEventId;
  } catch (error) {
    console.error('Error while sending image message: ', error);
    throw error;
  }
};
